import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { authcheck, getFullSourceID } from '@/libs/Authcheck';
import resources from '@/libs/resources';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        component: () => import('@/views/Home'),
        children: [
            {
                alias: '',
                path: '/首页',
                name: '首页',
                component: () => import('@/views/Home/Index'),
                meta: { type: 3 } // 1 需要主账号，2 系统资源，3 无需检查权限的个人资源
            }, {
                path: '店铺业务/数据图表',
                name: '数据图表',
                component: () => import('@/views/店铺业务/DataChart'),
                meta: { type: 1 }
            }, {
                path: '店铺业务/账务录入',
                name: '账务录入',
                component: () => import('@/views/店铺业务/AccountingEntry'),
                meta: { type: 1 }
            }, {
                path: '供货商业务/店铺派单',
                name: '店铺派单',
                component: () => import('@/views/供货商业务/DistributeOrders'),
                meta: { type: 1 }
            }, {
                path: '供货商业务/供货设置',
                name: '供货设置',
                component: () => import('@/views/供货商业务/SupplySettings'),
                meta: { type: 1 }
            }, {
                path: '供货商业务/工单管理',
                name: '工单管理',
                component: () => import('@/views/供货商业务/WorkOrder'),
                meta: { type: 1 }
            }, {
                path: '供货商业务/扣款管理',
                name: '扣款管理',
                component: () => import('@/views/供货商业务/WorkOrderDeduction'),
                meta: { type: 1 }
            }, {
                path: '主体财务/收支明细',
                name: '收支明细',
                component: () => import('@/views/主体财务/RevenueExpenditureDetails'),
                meta: { type: 1 }
            }, {
                path: '主体财务/充值提现',
                name: '充值提现',
                component: () => import('@/views/主体财务/RechargeWithdrawal'),
                meta: { type: 1 }
            }, {
                path: '主体财务/账务报销',
                name: '账务报销',
                component: () => import('@/views/主体财务/Reimbursement'),
                meta: { type: 1 }
            }, {
                path: '系统管理/主体管理',
                name: '主体管理',
                component: () => import('@/views/系统管理/MainUsersManage'),
                meta: { type: 2 }
            }, {
                path: '系统管理/角色管理',
                name: '角色管理',
                component: () => import('@/views/系统管理/RolesManage'),
                meta: { type: 2 }
            }, {
                path: '系统管理/用户管理',
                name: '用户管理',
                component: () => import('@/views/系统管理/UsersManage'),
                meta: { type: 2 }
            }, {
                path: '集团财务/财务审批',
                name: '财务审批',
                component: () => import('@/views/集团财务/FinancialApproval'),
                meta: { type: 2 }
            }, {
                path: '集团财务/报销审批',
                name: '报销审批',
                component: () => import('@/views/主体财务/Reimbursement'),
                meta: { type: 2 }
            }, {
                path: '用户信息',
                name: '用户信息',
                component: () => import('@/views/自己/UserInfo'),
            }
        ]
    }, {
        path: '/登录',
        name: '登录',
        component: () => import('@/views/Login')
    }
];


const router = new VueRouter({
    mode: 'history',
    routes
});

// 全局前置守卫
router.beforeEach(async (to, from, next) => {

    console.info('Vue Router beforeEach :', 'from:', from, 'to:', to);
    window.document.title = to.name;

    // BUG：从浏览器访问链接时，JS获取到的地址是经过encodeURI 的地址，由于路由路径是中文（UTF-8)的，所以会导航失败
    // 但是从Vue中跳转时，Vue Route 访问的是路由地址，是直接pushState 到 Histroy的，所以不会产生编码问题
    // 兼容中文路径访问，直接decodeURI，会返回UTF-8编码的字符串，若decodeURI成功，则跳转过去。
    const test = decodeURI(to.path);
    const path = test === to.path ? undefined : test;

    // 初始化系统。第一个路由from的name是null，（必须不是去登录页面，并且是从浏览器进来）
    if (from.name === null && ((to.path !== '/登录' && path) || to.path === '/')) await store.dispatch('systemInitialize');

    // 检查菜单访问权，若没有相关访问权，跳转到首页去。
    const source_id = getFullSourceID(to.name, to.path);
    if (to.meta.type === 1) {
        if (!authcheck(source_id, store.state.home.mainuser, false)) return next('/');
    }

    if (to.meta.type === 2) {
        if (!authcheck(source_id, false, false)) return next('/');
    }

    return next(path);
});

router.afterEach(() => {
})


console.log('router js');

window.router = router;
export default router
